import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { api } from '../../Api-Endpoints/apiEndpoint';
import logo from '../../assets/OHM_1.png';
import './DeleteAccount.scss';

const DeleteAccount = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [isDeleting, setIsDeleting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleDeleteAccount = async (e) => {
    e.preventDefault();
    const { email, password } = formData;
    
    if (!email || !password) {
      toast.error('Please fill in all fields');
      return;
    }

    setIsDeleting(true);
    try {
      const response = await api.post('/user/delete-by-credentials', {
        email,
        password
      });

      if (response.data.success) {
        toast.success('Account deleted successfully');
        // Redirect to login page after successful deletion
        setTimeout(() => {
          navigate('/login');
        }, 2000);
      } else {
        toast.error(response.data.msg || 'Failed to delete account');
      }
    } catch (error) {
      console.error('Error deleting account:', error);
      const errorMessage = error.response?.data?.msg || 'Failed to delete account';
      toast.error(errorMessage);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div className="loginSignUp">
      <div className="main">
        <div className="left">
          <div className="image">
            <img src={logo} alt="Logo" />
          </div>
          <div className="heading-sighin">
            <h2>Delete Account</h2>
          </div>
          <form onSubmit={handleDeleteAccount}>
            <div className="input-feild">
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="input-feild">
              <input
                type="password"
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="button">
              <button type="submit" disabled={isDeleting}>
                {isDeleting ? 'Deleting...' : 'Delete My Account'}
              </button>
            </div>
            <p className="warning-text">
              Warning: This action cannot be undone. All your data will be permanently deleted.
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default DeleteAccount;
